import * as ex from "excalibur";
import { CONFIG } from "../config";
export const landscapeImage = new ex.ImageSource("/assets/sprites/landscape.png", {
    filtering: ex.ImageFiltering.Pixel,
});
// All 128 sprite coordinates from landscape.xml (TexturePacker packed atlas).
// Index numbering follows Kenney's original 8-column sheet layout:
// index = (row - 1) * 8 + (col - 1)
const ATLAS = {
    landscapeTiles_000: { x: 265, y: 1057, width: 132, height: 83 },
    landscapeTiles_001: { x: 265, y: 1452, width: 132, height: 99 },
    landscapeTiles_002: { x: 265, y: 1369, width: 132, height: 83 },
    landscapeTiles_003: { x: 265, y: 1682, width: 132, height: 83 },
    landscapeTiles_004: { x: 529, y: 1191, width: 132, height: 99 },
    landscapeTiles_005: { x: 265, y: 1551, width: 132, height: 131 },
    landscapeTiles_006: { x: 265, y: 1947, width: 132, height: 99 },
    landscapeTiles_007: { x: 265, y: 1864, width: 132, height: 83 },
    landscapeTiles_008: { x: 266, y: 921, width: 132, height: 131 },
    landscapeTiles_009: { x: 0, y: 281, width: 133, height: 99 },
    landscapeTiles_010: { x: 397, y: 1183, width: 132, height: 83 },
    landscapeTiles_011: { x: 662, y: 693, width: 132, height: 99 },
    landscapeTiles_012: { x: 397, y: 1052, width: 132, height: 131 },
    landscapeTiles_013: { x: 793, y: 1303, width: 132, height: 99 },
    landscapeTiles_014: { x: 133, y: 380, width: 133, height: 83 },
    landscapeTiles_015: { x: 793, y: 1204, width: 132, height: 99 },
    landscapeTiles_016: { x: 793, y: 1121, width: 132, height: 83 },
    landscapeTiles_017: { x: 793, y: 990, width: 132, height: 131 },
    landscapeTiles_018: { x: 793, y: 891, width: 132, height: 99 },
    landscapeTiles_019: { x: 0, y: 0, width: 133, height: 99 },
    landscapeTiles_020: { x: 0, y: 99, width: 133, height: 83 },
    landscapeTiles_021: { x: 662, y: 594, width: 132, height: 99 },
    landscapeTiles_022: { x: 662, y: 495, width: 132, height: 99 },
    landscapeTiles_023: { x: 662, y: 396, width: 132, height: 99 },
    landscapeTiles_024: { x: 662, y: 297, width: 132, height: 99 },
    landscapeTiles_025: { x: 662, y: 198, width: 132, height: 99 },
    landscapeTiles_026: { x: 0, y: 380, width: 133, height: 99 },
    landscapeTiles_027: { x: 0, y: 1948, width: 133, height: 99 },
    landscapeTiles_028: { x: 661, y: 1946, width: 132, height: 99 },
    landscapeTiles_029: { x: 661, y: 1847, width: 132, height: 99 },
    landscapeTiles_030: { x: 661, y: 1748, width: 132, height: 99 },
    landscapeTiles_031: { x: 661, y: 1649, width: 132, height: 99 },
    landscapeTiles_032: { x: 661, y: 1550, width: 132, height: 99 },
    landscapeTiles_033: { x: 0, y: 1849, width: 133, height: 99 },
    landscapeTiles_034: { x: 0, y: 1552, width: 133, height: 99 },
    landscapeTiles_035: { x: 661, y: 1269, width: 132, height: 83 },
    landscapeTiles_036: { x: 661, y: 1138, width: 132, height: 131 },
    landscapeTiles_037: { x: 661, y: 1055, width: 132, height: 83 },
    landscapeTiles_038: { x: 661, y: 956, width: 132, height: 99 },
    landscapeTiles_039: { x: 530, y: 857, width: 132, height: 99 },
    landscapeTiles_040: { x: 530, y: 758, width: 132, height: 99 },
    landscapeTiles_041: { x: 133, y: 0, width: 133, height: 99 },
    landscapeTiles_042: { x: 133, y: 198, width: 133, height: 83 },
    landscapeTiles_043: { x: 530, y: 461, width: 132, height: 99 },
    landscapeTiles_044: { x: 530, y: 378, width: 132, height: 83 },
    landscapeTiles_045: { x: 530, y: 295, width: 132, height: 83 },
    landscapeTiles_046: { x: 530, y: 198, width: 132, height: 97 },
    landscapeTiles_047: { x: 530, y: 99, width: 132, height: 99 },
    landscapeTiles_048: { x: 0, y: 479, width: 133, height: 99 },
    landscapeTiles_049: { x: 0, y: 578, width: 133, height: 99 },
    landscapeTiles_050: { x: 529, y: 1834, width: 132, height: 99 },
    landscapeTiles_051: { x: 529, y: 1751, width: 132, height: 83 },
    landscapeTiles_052: { x: 529, y: 1668, width: 132, height: 83 },
    landscapeTiles_053: { x: 529, y: 1585, width: 132, height: 83 },
    landscapeTiles_054: { x: 529, y: 1488, width: 132, height: 97 },
    landscapeTiles_055: { x: 529, y: 1389, width: 132, height: 99 },
    landscapeTiles_056: { x: 0, y: 677, width: 133, height: 83 },
    landscapeTiles_057: { x: 0, y: 760, width: 133, height: 99 },
    landscapeTiles_058: { x: 529, y: 1108, width: 132, height: 83 },
    landscapeTiles_059: { x: 529, y: 1009, width: 132, height: 99 },
    landscapeTiles_060: { x: 398, y: 926, width: 132, height: 83 },
    landscapeTiles_061: { x: 398, y: 843, width: 132, height: 83 },
    landscapeTiles_062: { x: 398, y: 744, width: 132, height: 99 },
    landscapeTiles_063: { x: 0, y: 958, width: 133, height: 99 },
    landscapeTiles_064: { x: 0, y: 1057, width: 133, height: 99 },
    landscapeTiles_065: { x: 398, y: 447, width: 132, height: 99 },
    landscapeTiles_066: { x: 398, y: 364, width: 132, height: 83 },
    landscape_grass_flat_ground: { x: 398, y: 265, width: 132, height: 99 },
    landscapeTiles_068: { x: 398, y: 166, width: 132, height: 99 },
    landscapeTiles_069: { x: 398, y: 83, width: 132, height: 83 },
    landscapeTiles_070: { x: 398, y: 0, width: 132, height: 83 },
    landscapeTiles_071: { x: 0, y: 1156, width: 133, height: 99 },
    landscapeTiles_072: { x: 0, y: 1255, width: 133, height: 99 },
    landscapeTiles_073: { x: 397, y: 1745, width: 132, height: 83 },
    landscapeTiles_074: { x: 397, y: 1646, width: 132, height: 99 },
    landscape_grass_flat: { x: 397, y: 1547, width: 132, height: 99 },
    landscapeTiles_076: { x: 397, y: 1464, width: 132, height: 83 },
    landscapeTiles_077: { x: 793, y: 1402, width: 132, height: 83 },
    landscapeTiles_078: { x: 133, y: 760, width: 133, height: 99 },
    landscapeTiles_079: { x: 0, y: 182, width: 133, height: 99 },
    landscapeTiles_080: { x: 662, y: 792, width: 132, height: 99 },
    landscapeTiles_081: { x: 662, y: 0, width: 132, height: 99 },
    landscape_street_ns: { x: 662, y: 99, width: 132, height: 99 },
    landscapeTiles_083: { x: 266, y: 723, width: 132, height: 99 },
    landscapeTiles_084: { x: 661, y: 1451, width: 132, height: 99 },
    landscapeTiles_085: { x: 661, y: 1352, width: 132, height: 99 },
    landscapeTiles_086: { x: 0, y: 1651, width: 133, height: 99 },
    landscapeTiles_087: { x: 133, y: 281, width: 133, height: 99 },
    landscapeTiles_088: { x: 530, y: 659, width: 132, height: 99 },
    landscape_street_intersection_ns_nw: {
        x: 530,
        y: 560,
        width: 132,
        height: 99,
    },
    landscape_street_intersection_nesw: { x: 266, y: 0, width: 132, height: 99 },
    landscapeTiles_091: { x: 529, y: 1933, width: 132, height: 99 },
    landscapeTiles_092: { x: 530, y: 0, width: 132, height: 99 },
    landscapeTiles_093: { x: 133, y: 958, width: 133, height: 99 },
    landscapeTiles_094: { x: 0, y: 859, width: 133, height: 99 },
    landscapeTiles_095: { x: 529, y: 1290, width: 132, height: 99 },
    landscape_street_intersection_ns_se: {
        x: 398,
        y: 546,
        width: 132,
        height: 99,
    },
    landscape_street_intersection_ew_sw: {
        x: 398,
        y: 645,
        width: 132,
        height: 99,
    },
    landscapeTiles_098: { x: 265, y: 1238, width: 132, height: 131 },
    landscapeTiles_099: { x: 397, y: 1828, width: 132, height: 99 },
    landscapeTiles_100: { x: 397, y: 1927, width: 132, height: 99 },
    landscapeTiles_101: { x: 0, y: 1453, width: 133, height: 99 },
    landscapeTiles_102: { x: 0, y: 1354, width: 133, height: 99 },
    landscapeTiles_103: { x: 266, y: 822, width: 132, height: 99 },
    landscape_street_intersection_ew_ne: {
        x: 266,
        y: 624,
        width: 132,
        height: 99,
    },
    landscape_street_end_e: { x: 266, y: 525, width: 132, height: 99 },
    landscapeTiles_106: { x: 133, y: 1844, width: 132, height: 131 },
    landscapeTiles_107: { x: 133, y: 859, width: 133, height: 99 },
    landscapeTiles_108: { x: 133, y: 661, width: 133, height: 99 },
    landscapeTiles_109: { x: 133, y: 1057, width: 132, height: 131 },
    landscapeTiles_110: { x: 133, y: 1188, width: 132, height: 99 },
    landscape_street_end_s: { x: 133, y: 1515, width: 132, height: 99 },
    landscape_street_end_w: { x: 133, y: 1287, width: 132, height: 99 },
    landscapeTiles_113: { x: 133, y: 562, width: 133, height: 99 },
    landscapeTiles_114: { x: 133, y: 463, width: 133, height: 99 },
    landscapeTiles_115: { x: 133, y: 1713, width: 132, height: 131 },
    landscapeTiles_116: { x: 266, y: 99, width: 132, height: 99 },
    landscape_street_end_n: { x: 133, y: 1614, width: 132, height: 99 },
    landscapeTiles_118: { x: 133, y: 99, width: 133, height: 99 },
    landscapeTiles_119: { x: 265, y: 1765, width: 132, height: 99 },
    landscapeTiles_120: { x: 266, y: 297, width: 132, height: 129 },
    landscapeTiles_121: { x: 266, y: 426, width: 132, height: 99 },
    landscapeTiles_122: { x: 0, y: 1750, width: 133, height: 99 },
    landscape_street_corner_se: { x: 266, y: 198, width: 132, height: 99 },
    landscapeTiles_124: { x: 133, y: 1386, width: 132, height: 129 },
    landscape_street_corner_ne: { x: 397, y: 1266, width: 132, height: 99 },
    landscape_street_corner_sw: { x: 397, y: 1365, width: 132, height: 99 },
    landscape_street_corner_nw: { x: 265, y: 1140, width: 132, height: 98 },
};
// Ground/flat tiles in this atlas are 99px tall: 66px diamond + 33px front wall.
// We take the first 82px of source height (approx. 2× of 40px dest). The diamond
// top vertex is at y=0 of the source rect — do NOT crop from the top or the tip
// is lost. destSize width 64 and height 40 give a 32px diamond + 8px front wall,
// matching TILE_WIDTH=64 and TILE_HEIGHT=32 exactly (both multiples of 4, so all
// tile grid positions are integers and diagonal edges land on exact pixels).
const KENNEY_BASE_SOURCE_HEIGHT = 82;
const KENNEY_BASE_DEST_HEIGHT = 40; // 32px diamond + 8px front wall
// Exported for canvas-based tile pre-rendering in BackgroundCanvas.ts
export const GRASS_FLAT_ATLAS_RECT = ATLAS["landscape_grass_flat"];
export const KENNEY_SRC_H = KENNEY_BASE_SOURCE_HEIGHT; // 82
export const KENNEY_DEST_H = KENNEY_BASE_DEST_HEIGHT; // 40
// Generalizes the grass_flat scaling rule (crop bottom 17px, scale 82->40) to any tile height
// in this atlas (the sheet mixes 83/97/99/129/131px sources). Reproduces KENNEY_SRC_H/DEST_H
// exactly for height-99 tiles. The crop is capped at KENNEY_BASE_SOURCE_HEIGHT: ground sprites
// are bottom-aligned to a shared ground line (see drawLandscapeSprite) and this simple
// per-lattice-point canvas draw has no real depth sorting, so a sprite taller than the
// standard tile (e.g. the 131px-source tree) would extend above that line and z-fight with
// whichever neighboring tile paints next — capping keeps every ground sprite within the
// standard footprint. Shorter sprites (e.g. water, 83px) are uncapped and legitimately render
// shorter, reaching down to meet the same ground line. Verify each newly chosen sprite
// visually — see BackgroundCanvas.
function renderInfo(rect) {
    const srcCropH = Math.min(rect.height - 17, KENNEY_BASE_SOURCE_HEIGHT);
    const destH = Math.round((srcCropH * KENNEY_BASE_DEST_HEIGHT) / KENNEY_BASE_SOURCE_HEIGHT);
    return { rect, srcCropH, destH };
}
// Per-terrain-cell ground sprites (see shared/terrain.ts for the cell model).
export const TERRAIN_SPRITES = {
    grass: renderInfo(ATLAS["landscape_grass_flat"]),
    grass2: renderInfo(ATLAS["landscapeTiles_016"]), // visual variety only — no rule differs from grass
    water: renderInfo(ATLAS["landscapeTiles_066"]),
    tree: renderInfo(ATLAS["landscapeTiles_098"]), // tall (131px source) — see maxDestH in BackgroundCanvas
};
// Street ground sprites — full 16-case autotile set (see edgeBitmask in shared/terrain.ts:
// bit0=N, bit1=E, bit2=S, bit3=W). `straightNS` connects north+south; flip it horizontally
// for east+west (a flip swaps N<->W and E<->S, so an opposite-edge pair maps cleanly onto the
// other opposite pair). Corners and end-caps are named by the grid direction(s) they connect
// (not screen position — see shared/terrain.ts for how N/E/S/W map to diamond edges). Only the
// isolated tile (0 connections) still falls back to `generic`.
export const STREET_SPRITES = {
    generic: renderInfo(ATLAS["landscapeTiles_081"]),
    straightNS: renderInfo(ATLAS["landscape_street_ns"]),
    cross: renderInfo(ATLAS["landscape_street_intersection_nesw"]),
    // T-junctions are named by their through-pair plus the branch direction they add.
    tNSW: renderInfo(ATLAS["landscape_street_intersection_ns_nw"]), // N+S+W (no E)
    tNSE: renderInfo(ATLAS["landscape_street_intersection_ns_se"]), // N+S+E (no W)
    tEWS: renderInfo(ATLAS["landscape_street_intersection_ew_sw"]), // E+W+S (no N)
    tEWN: renderInfo(ATLAS["landscape_street_intersection_ew_ne"]), // E+W+N (no S)
    cornerNE: renderInfo(ATLAS["landscape_street_corner_ne"]),
    cornerSE: renderInfo(ATLAS["landscape_street_corner_se"]),
    cornerSW: renderInfo(ATLAS["landscape_street_corner_sw"]),
    cornerNW: renderInfo(ATLAS["landscape_street_corner_nw"]),
    endN: renderInfo(ATLAS["landscape_street_end_n"]),
    endE: renderInfo(ATLAS["landscape_street_end_e"]),
    endS: renderInfo(ATLAS["landscape_street_end_s"]),
    endW: renderInfo(ATLAS["landscape_street_end_w"]),
};
// A bridge is rendered as a Building actor (see actors/Building.ts) but is visually a flat
// ground overlay, so it uses the same cropped terrain-style rendering as TERRAIN_SPRITES.
export const BRIDGE_SPRITE = renderInfo(ATLAS["landscapeTiles_038"]);
const DEST_W = 64; // TILE_WIDTH — terrain/street/bridge sprites all scale to this uniformly
// Every source tile shares the same diamond footprint and differs only in front-wall/base
// depth below it (see KENNEY_BASE_* above) — so all ground sprites must share one ground
// line, not each hang from the same top-left point. A shorter tile (e.g. water, destH=32)
// has to reach down exactly as far as a standard flat tile (destH=40); a taller one (e.g. a
// raised tree mound) instead stands on that same line and extends upward beyond it.
const GROUND_LINE_H = KENNEY_BASE_DEST_HEIGHT;
// Anchor for ground-overlay Building actors (currently only the bridge). Unlike a building
// cube — whose graphic bottom edge IS the base diamond's bottom vertex, see
// BuildingAtlas.anchorYForHeight — a renderInfo() sprite keeps the same front-wall strip
// below the diamond that every TERRAIN_SPRITES/STREET_SPRITES tile has (see
// drawLandscapeSprite's GROUND_LINE_H bottom-align below). Reusing the building formula here
// sits the sprite one front-wall's worth of pixels too high; anchoring to the same ground
// line every other ground tile uses keeps the bridge's base plate flush with the terrain
// regardless of its own destH.
export function anchorYForGroundOverlay(destH) {
    return 1 - (GROUND_LINE_H - CONFIG.TILE_HEIGHT / 2) / destH;
}
export const BRIDGE_ANCHOR_Y = anchorYForGroundOverlay(BRIDGE_SPRITE.destH);
// Draws a terrain/street sprite into a canvas 2D context at chunk-local coordinates (px, py) —
// py is the lattice point's standard ground line, not this sprite's own top-left — optionally
// mirrored (used to derive the north-south street orientation from `straightEW`).
export function drawLandscapeSprite(ctx, info, px, py, flipHorizontal = false) {
    const img = landscapeImage.data;
    if (!img)
        return;
    const { rect, srcCropH, destH } = info;
    const drawY = py + (GROUND_LINE_H - destH); // bottom-align to the shared ground line
    if (!flipHorizontal) {
        ctx.drawImage(img, rect.x, rect.y, rect.width, srcCropH, px, drawY, DEST_W, destH);
        return;
    }
    ctx.save();
    ctx.translate(px + DEST_W, drawY);
    ctx.scale(-1, 1);
    ctx.drawImage(img, rect.x, rect.y, rect.width, srcCropH, 0, 0, DEST_W, destH);
    ctx.restore();
}
// For Building actors that render a flat ground overlay (currently: the bridge).
export function createLandscapeSprite(info) {
    return new ex.Sprite({
        image: landscapeImage,
        sourceView: {
            x: info.rect.x,
            y: info.rect.y,
            width: info.rect.width,
            height: info.srcCropH,
        },
        destSize: { width: DEST_W, height: info.destH },
    });
}
